import Vue from 'vue';
import Router from 'vue-router';
import home from '@/components/Home';
import begin from '@/components/BeginSurvey';
import beginRegister from '@/components/registration/beginRegister';
import survey from '@/components/SurveyPage';
import finalsurvey from '@/components/FinalSurvey';
import finalsurvey10 from '@/components/FinalSurvey10';
import finalsurvey11 from '@/components/FinalSurvey11';
import contact from '@/components/Contact';
import terms from '@/components/Terms';
import Regulation from '@/components/Regulation.vue';
import NProgress from 'nprogress';



Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: "/",
            redirect: {
                name: "home"
            }
        },
        {
            path: '/home',
            name: 'home',
            component: home
        },
        {
            path: '/beginRegister',
            name: 'beginRegister',
            component: beginRegister
        },
        {
            path: '/beginSurvey',
            name: 'beginSurvey',
            component: begin
        },
        {
            path: '/survey',
            name: 'survey',
            component: survey
        },
        {
            path: '/finalsurvey',
            name: 'finalsurvey',
            component: finalsurvey
        },
        {
            path: '/finalsurvey10',
            name: 'finalsurvey10',
            component: finalsurvey10
        },
        {
            path: '/finalsurvey11',
            name: 'finalsurvey11',
            component: finalsurvey11
        },
        {
            path: '/contact',
            name: 'contact',
            component: contact,
        },
        {
            path: '/terms',
            name: 'terms',
            component: terms,
        },
        {
            path: '/Regulation',
            name: 'Regulation',
            component: Regulation,
        }
        /*{
            path: '*',
            name: 'notfound',
            component: notfound
        }*/
    ],
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

router.beforeEach((routeTo, routeFrom, next) => {
    NProgress.start()
    next()
})

router.afterEach(() => {
    NProgress.done()
})

export default router
